import HTTP from '@/plugins/http';

const passwdApi = {
  pay: '/merchant/restPassword',
  updatePay: '/merchant/payPass/modify',
  login: '/admin/updatePassword'
};

function resetPay(params) {
  return HTTP.loading({
    url: passwdApi.pay,
    method: 'get',
    params
  });
}

function updatePasswd(data) {
  return HTTP.loading({
    url: passwdApi.login,
    method: 'post',
    data
  });
}

function updatePay(data) {
  return HTTP.loading({
    url: passwdApi.updatePay,
    method: 'post',
    data
  });
}
export default { resetPay, updatePasswd, updatePay };



// WEBPACK FOOTER //
// ./src/api/passwd.js